
// Vue.component('dummy', require('./vue/dummy.vue').default);

Vue.component('mc-app-flow-debug', require('./SysopBoards/vue/mc-app-flow-debug').default);
Vue.component('direct-app-flow-debug', require('./SysopBoards/vue/direct-app-flow-debug').default);
Vue.component('delivery-test-debug', require('./SysopBoards/vue/delivery-test-debug').default);